<template>
    <div class="contacts">
        <div class="contacts__links">
            <a href="https://t.me/cheersgyu" target="_blank" class="contacts__link">
                <img src="@/assets/img/tg_icon.svg" alt="Telegram">
            </a>
            <a href="https://www.instagram.com/you.course/" target="_blank" class="contacts__link">
                <img src="@/assets/img/inst_icon.svg" alt="Instagram">
            </a>
        </div>
        <div class="contacts__logo">
            <img src="@/assets/img/logo.png" alt="Logo">
        </div>
        <div class="contacts__creds">
            <span>You.Course</span>
            <span>04 | 2022</span>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MainContacts'
}
</script>

<style lang="scss">
.contacts {
    width: 448px;
    padding: 0 115px;
    margin: -150px auto 0;
    background: #fbf8f4;
    @media (max-width: 767px) {
        width: auto;
        padding: 0;
    }

    &__links {
        display: flex;
        gap: 15px;
        justify-content: center;
    }

    &__link {
        width: 50px;
        height: 50px;
        min-width: 50px;
    }

    &__logo {
        width: 218px;
        height: 90px;
        margin: 30px auto 0;

        & img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &__creds {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: 30px;
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 15px;
        line-height: 18px;
        text-align: center;
        color: rgba(67, 66, 66, 0.67);
    }
}
</style>
